import OptionPanel from './OptionPanel';
export default OptionPanel;
